import { observer } from "mobx-react";
import React from "react";
import { PositionedSpinner } from "../../../../../../../../components/ui/PositionedSpinner";
import { ImpactTypesSidebarModel } from "./ImpactTypesSidebar_model";
import { SingleForm } from "../../../../../../../../pages/change/forms/singleFormModel/SingleForm_view";

export interface ImpactTagsSidebarProps {
  model: ImpactTypesSidebarModel;
}

export const ImpactTypesSidebar: React.FC<ImpactTagsSidebarProps> = observer(({ model }) => {
  if (model.isLoading) return <PositionedSpinner />;

  return (
    <div className="container-fluid">
      <SingleForm model={model.formModel} />
    </div>
  );
});
